import React from 'react'
import {bindActionCreators} from "redux"
import { connect } from 'react-redux'
import {Row, Col, Icon, Radio, Card, Tooltip, Spin} from 'antd'
import { message } from 'antd'

import SyntaxHighlighter from 'react-syntax-highlighter'
import { docco } from 'react-syntax-highlighter/dist/esm/styles/hljs'
import { CopyToClipboard } from 'react-copy-to-clipboard'

import {changeAuthenticationInChat, changeNowSettingsRequest} from "../../../redux/Ekko/actions"

const radioStyle = {
    display: 'block',
    height: '30px',
    lineHeight: '30px',
};

class NowSettings extends React.Component {
    constructor(props) {
        super(props)
    }

    changePositionSettings = (e) => {
        const { changeNowSettingsRequest } = this.props

        changeNowSettingsRequest({ position: e.target.value })
    }

    changeBottomOffsetSettings = (e) => {
        const { changeNowSettingsRequest } = this.props

        changeNowSettingsRequest({ bottom_offset: e.target.value })
    }

    changeAuthorizationChatOneToOne = (e) => {
        const { changeNowSettingsRequest } = this.props

        changeNowSettingsRequest({ one_to_one_channels: e.target.value })
    }

    changeAuthentication = (e) => {
        this.props.changeAuthenticationInChat(e.target.value)
    }

    changeHideSettings = (e) => {
        const { changeNowSettingsRequest } = this.props

        changeNowSettingsRequest({ hide_widget: e.target.value })
    }

    render() {
        return (
            <div>
                <Spin spinning={this.props.loadingCurrentApp} delay={100}>
                    <Row>
                        <Col xs={22} md={8}>
                            <h3>Authentication for sending message</h3>

                            <Radio.Group onChange={this.changeAuthentication} value={this.props.currentApp.authentication_in_chat}>
                                <Radio style={radioStyle} value={null}>
                                    Anyone
                                </Radio>
                                <Radio style={radioStyle}  value={"username"}>
                                    Username required
                                </Radio>
                                <Radio style={radioStyle}  value={"username-email"}>
                                    Username and email required
                                </Radio>
                                <Radio style={radioStyle}  value={"username-email-verified"}>
                                    Username and email verified required
                                </Radio>
                            </Radio.Group>
                        </Col>
                        <Col xs={22} md={5}>
                            <h3>Widget position</h3>

                            <Radio.Group onChange={this.changePositionSettings} value={this.props.currentApp.now_settings.position}>
                                <Radio style={radioStyle}  value={"left"}>
                                    Left
                                </Radio>
                                <Radio style={radioStyle}  value={"right"}>
                                    Right
                                </Radio>
                            </Radio.Group>
                        </Col>
                        <Col xs={24} md={6}>
                            <h3>Users can chat between them </h3>

                            <Radio.Group onChange={this.changeAuthorizationChatOneToOne} value={this.props.currentApp.now_settings.one_to_one_channels}>
                                <Radio style={radioStyle}  value={true}>
                                    Yes
                                </Radio>
                                <Radio style={radioStyle}  value={false}>
                                    No
                                </Radio>
                            </Radio.Group>
                        </Col>
                    </Row>
                    <Row style={{marginTop: 35}}>
                        <Col xs={24} md={8}>
                            <h3>
                                Widget bottom offset
                                <Tooltip title="1 unit represent the space required for 1 other widget below Ekko Now.">
                                    <Icon type="info-circle" style={{ color: 'rgba(0,0,0,.45)', marginLeft: 8, fontSize: 16 }} />
                                </Tooltip>
                            </h3>

                            <Radio.Group value={this.props.currentApp.now_settings.bottom_offset} onChange={this.changeBottomOffsetSettings}>
                                <Tooltip title="Default value">
                                    <Radio.Button value={0}>0</Radio.Button>
                                </Tooltip>
                                <Tooltip title="125px">
                                    <Radio.Button value={1}>1</Radio.Button>
                                </Tooltip>
                                <Tooltip title="250px">
                                    <Radio.Button value={2}>2</Radio.Button>
                                </Tooltip>
                            </Radio.Group>
                        </Col>
                        <Col xs={22} md={5}>
                            <h3>
                                Hide widget
                            </h3>

                            <Radio.Group value={this.props.currentApp.now_settings.hide_widget} onChange={this.changeHideSettings}>
                                <Radio style={radioStyle}  value={true}>
                                    Yes
                                </Radio>
                                <Radio style={radioStyle}  value={false}>
                                    No
                                </Radio>
                            </Radio.Group>
                        </Col>
                    </Row>
                </Spin>
            </div>

        )
    }
}

const mapStateToProps = state => ({
    currentApp: state.ekko.currentApp,
    loadingCurrentApp: state.ekko.loadingCurrentApp,
})

const mapActionsToProps = dispatch => ({
    changeNowSettingsRequest: bindActionCreators(changeNowSettingsRequest, dispatch),
    changeAuthenticationInChat: bindActionCreators(changeAuthenticationInChat, dispatch),
})

export default connect(
    mapStateToProps,
    mapActionsToProps
)(NowSettings)
